<template>
  <div class="inner-page" >
	  <div class="header">
		  <h3>Archive</h3>
<!--		  <v-button @click="newPopupOpen=true" label="Create a new automation" :locked="!is('automations')"  />-->
<!--		  <portal to="popup">-->
<!--			  <new-automation-popup v-if="newPopupOpen" @close="newPopupOpen=false"/>-->
<!--		  </portal>-->
	  </div>

	  <Loading v-if="loading"/>

    <div v-else class="__automations_panel">
	    <div class="search-container">
		    <input type="text" placeholder="Type to search..." class="search-input"
		           @input="searchValueChanged" v-model="searchValue">
	    </div>

	    <div class="entries-table" v-if="filteredAutomations.length">
	      <archive-automation-entry :automation="item" v-for="(item, index) in filteredAutomations" :key="index + '_' + item.id"
	                        @cloned="automationCloned" />
      </div>
	    <p v-else-if="automations.length" style="margin: auto">No deleted automations match your search query</p>
      <p v-else style="margin: auto">No automations have been deleted yet</p>
    </div>
  </div>
</template>

<script>
import AutomationsDeletePopup from "@/components/popups/delete/AutomationsDeletePopup.vue"
import {mapGetters} from "vuex"
import API from "@/api"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import NewAutomationPopup from "@/views/automations/new-automation-popup";
import {is} from "@/helpers/roles";
import AutomationEntry from "@/views/automations/automation-entry";
import ArchiveAutomationEntry from "@/views/automations/archive-automation-entry";

export default {
    name: "automations-archive",
    components: {
	    ArchiveAutomationEntry,
	    AutomationEntry,
	    NewAutomationPopup,
	    VButton,
        AutomationsDeletePopup,
        Loading,
    },
    mixins: [API],
    data: function() {
        return {
	        searchValue:'',
        	newPopupOpen: false,
            automations: [],
            integrations: [],
            stepData: [],
            funnel: {},
            loading: true,
            automationId: '',
            automationItem: {},
        };
    },
    computed: {
	    filteredAutomations() {
		    let search = this.searchValue.toLowerCase();
		    return this.automations.filter(item => item.name.toLowerCase().indexOf(search) >= 0);
	    },
    },
    methods: {
	    searchValueChanged() {
		    localStorage.setItem('automations_search_value', this.searchValue)
	    },
	    automationDeleted(automation) {
		    let i = this.automations.findIndex(x=>x.id===automation.id);
		    if (i>=0) this.automations.splice(i,1)
	    },
	    automationCloned(automation) {
				if (!automation) return;
		    this.automations.push(automation)
	    },
			is(role){
				return is(role)
			},
        async activateItem(item) {
            item.is_active = !item.is_active;
            var {id} = this.$route.params;
            var result = await this.api.automations.patch(id, item.id, item);
            console.log({result});
        },

        async deleteCurrentAutomation(thisItem){
            let data = {
                "id": thisItem.id,
                "funnel_id": thisItem.funnel_id,
                "user_id": thisItem.user_id
            }

            var result = await this.api.automations.delete(thisItem.funnel_id, data);
            this.$store.commit("closeAutomationsDeletePopup");

            this.init(this.$route.params.id);
        },
        showAutomationsDeletePopup(thisAutomationItem) {
            this.automationItem = thisAutomationItem;
            this.$store.commit("showAutomationsDeletePopup");
        },
        async copyAutomation(item){
            var {id} = this.$route.params;
            var result = await this.api.automations.create(id, item);
            console.log({result});
            this.init();
        },

        async init() {
					try {
						this.loading = true;

						this.automations = [];
						this.automations = await this.api.globalAutomations.getAllDeleted();
					} catch (e) {
						this.$error(e)
					} finally {
						this.loading = false;
					}
        }
    },
    created() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
.__automations_panel {
	display: flex;
	flex-direction: column;
	flex: 1;
	margin: 10px 30px 50px;
}
.entry {
	min-height: 30px;
	padding: 0 10px;
	.panel_item_right, .panel_item_left {
		padding: 3px 0;
	}
	.panel_item_btn {
		min-width: 34px;
		min-height: 34px;
		width: 34px;
		height: 34px;
		svg {
			//height: 18px;
			//width: 18px;
		}
	}
}
.automations_item_img {
	color: $blue;
	margin-right: 5px;
	svg {
		opacity: .7;
		height: 24px;
	}
}
</style>

